import { useTranslationNS } from './useTranslationNS'

export const useTranslation = () => useTranslationNS('main')
